import axios from 'axios'
import { centsInSpan } from '../../../utils/euros'

export default {
  namespaced: false,
  state: {
    allVehicles: [],
  },
  mutations: {
    SET_VEHICLE_LIST(state, allVehicles) {
      state.allVehicles = [
        ...allVehicles.map((car) => ({
          ...car,
          rrs_category: {
            ...car.rrs_category,
            formattedStartingPrice: centsInSpan(
              car.rrs_category.starting_price.raw,
            ),
          },
        })),
      ]
    },
  },
  actions: {
    async GET_VEHICLE_LIST({ commit, rootState }) {
      axios(`${rootState.api}/vehicles`).then((res) => {
        commit('SET_VEHICLE_LIST', res.data.data)
      })
    },
  },
}
